/**
 * Name: Gallery
 */

import Component from "@lunaweb/vega-reactor-js/src/patterns/Component";
import Parvus from "parvus";

export default class Gallery extends Component {

  static settings = {};

  #items = [];
  #gallery;

  constructor (element, options = {}) {
    super(element, {
      ...Gallery.settings,
      ...options
    });

    this.#items = this.element.querySelectorAll('.js-gallery-item');
  }

  mount () {
    this.#gallery = new Parvus({
      l10n: {
        lightboxLabel: "Ceci est une boîte de dialogue qui se superpose au contenu de la page. Elle affiche des images en plein écran. Appuyer sur la touche d'échappement pour fermer cette boîte de dialogue et poursuivre votre navigation.",
        lightboxLoadingIndicatorLabel: "Indicateur de chargement",
        lightboxLoadingError: "Cette image n'a pas pu être chargée.",
        controlsLabel: "Contrôles",
        previousButtonLabel: "Image précédente",
        nextButtonLabel: "Image suivante",
        closeButtonLabel: "Fermer la boîte de dialogue",
        sliderLabel: "Images",
        slideLabel: "Image",
      },
      selector: '.js-gallery-item',
      zoomIndicator: false,
      previousButtonIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M15 20.67a.74.74 0 0 1-.53-.22l-6.52-6.52a2.74 2.74 0 0 1 0-3.86l6.52-6.52a.75.75 0 0 1 1.06 0c.3.29.3.77 0 1.06l-6.52 6.52a1.23 1.23 0 0 0 0 1.74l6.52 6.52c.3.29.3.77 0 1.06a.79.79 0 0 1-.53.22Z"/></svg>',
      nextButtonIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M8.91 20.67a.74.74 0 0 1-.53-.22.75.75 0 0 1 0-1.06l6.52-6.52c.48-.48.48-1.26 0-1.74L8.38 4.61a.75.75 0 0 1 0-1.06.75.75 0 0 1 1.06 0l6.52 6.52a2.72 2.72 0 0 1 0 3.86l-6.52 6.52a.79.79 0 0 1-.53.22Z"/></svg>',
      closeButtonIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="m13.06 12 5.83-5.83c.29-.29.29-.77 0-1.06s-.77-.29-1.06 0L12 10.94 6.17 5.11c-.29-.29-.77-.29-1.06 0s-.29.77 0 1.06L10.94 12l-5.83 5.83c-.29.29-.29.77 0 1.06s.77.29 1.06 0L12 13.06l5.83 5.83c.29.29.77.29 1.06 0s.29-.77 0-1.06z"/></svg>',
      captionsAttribute: 'data-caption'
    });

    super.mount();
  }

  unmount () {
    this.#gallery.destroy();
    this.#gallery = null;
    super.unmount();
  }
}
